module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/union_activity-99d64def.png";